<template>
    <div>
        <v-row>
            <v-col cols="3">
                <v-text-field
                    v-model="routingSearch"
                    outlined
                    dense
                    append-icon="mdi-search"
                    :label="$t('settings.routing.search_placeholder')"
                    single-line
                    hide-details
                >
                </v-text-field>
            </v-col>

            <v-col cols="5"></v-col>

            <v-col cols="4" class="text-right">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="blue-grey"
                            :loading="loading"
                            small
                            v-bind="attrs"
                            v-on="on"
                            @click="resetFileInput"
                        >
                            <v-icon dark dense> mdi-file-upload </v-icon>
                            <input
                                type="file"
                                ref="routingFile"
                                @change="
                                    (event) => readFile(event.target.files[0])
                                "
                                accept=".csv"
                                style="display: none"
                            />
                        </v-btn>
                    </template>
                    <span>{{ $t("common.file.uploadSettingsFromCSV") }}</span>
                </v-tooltip>

                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="blue-grey"
                            class="ml-2"
                            :loading="loading"
                            small
                            v-bind="attrs"
                            v-on="on"
                        >
                            <download-excel
                                :data="filterSortData"
                                :fields="csvFields"
                                style="display: inline"
                                type="csv"
                                :name="'RoutingSettings.csv'"
                                :escapeCsv="false"
                            >
                                <v-icon dark dense>
                                    mdi-microsoft-excel
                                </v-icon>
                            </download-excel>
                        </v-btn>
                    </template>
                    <span>{{ $t("common.file.downloadSettingsToCSV") }}</span>
                </v-tooltip>

                <v-btn
                    small
                    color="blue-grey"
                    class="ml-2"
                    @click="refreshRouting"
                    :loading="loading"
                    ><v-icon>mdi-refresh</v-icon></v-btn
                >
                <v-btn
                    small
                    color="primary"
                    class="ml-2"
                    :loading="loading"
                    v-on:click="toggleDialog('add')"
                    >{{ $t("common.form.add") }}</v-btn
                >
                <v-btn
                    small
                    color="primary"
                    class="ml-2"
                    :disabled="!changed"
                    @click="updateData"
                    >{{ $t("settings.routing.saveAndApply") }}</v-btn
                >
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-data-table
                    dense
                    :search="routingSearch"
                    :headers="routingHeader"
                    :items="filterSortData"
                    item-key="id"
                    class="elevation-0"
                    :loading="loading"
                    disable-sort
                    id="home-table"
                    :footer-props="{
                        'items-per-page-options': [10, 20, 30, 50],
                        'items-per-page-text': $t('common.table.rowsPerPage'),
                    }"
                    :hide-default-footer="false"
                    :header-props="{ sortIcon: null }"
                    fixed-header
                    :page.sync="currentPage"
                    :items-per-page.sync="itemsPerPage"
                >
                    <template v-slot:header.book_a_name="{ header }">
                        {{ header.text }}
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    color="grey"
                                    style="padding-bottom: 3px"
                                >
                                    mdi-information
                                </v-icon>
                            </template>
                            <span>{{
                                $t("settings.routing.bookaTooltip")
                            }}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:header.book_b_name="{ header }">
                        {{ header.text }}
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    color="grey"
                                    style="padding-bottom: 3px"
                                >
                                    mdi-information
                                </v-icon>
                            </template>
                            <span>{{
                                $t("settings.routing.bookbTooltip")
                            }}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:header.is_override="{ header }">
                        {{ header.text }}
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    small
                                    color="grey"
                                    style="padding-bottom: 3px"
                                >
                                    mdi-information
                                </v-icon>
                            </template>
                            <span>{{
                                $t("settings.routing.isOverrideTooltip")
                            }}</span>
                        </v-tooltip>
                    </template>
                    <template v-slot:body="props">
                        <!-- v-model="filterSortData" -->
                        <draggable
                            tag="tbody"
                            :list="currentPageItems"
                            @end="onDragEnd"
                            item-key="id"
                        >
                            <tr
                                v-for="(detail, index) in props.items"
                                :key="index"
                            >
                                <td>
                                    <v-icon small class="page__grab-icon"
                                        >mdi-arrow-all</v-icon
                                    >
                                </td>
                                <td>{{ detail.id }}</td>
                                <td>{{ detail.server_name }}</td>
                                <td style="white-space: nowrap">
                                    <div
                                        v-if="detail.filter_login.length >= 25"
                                    >
                                        {{ detail.filter_login.slice(0, 25)
                                        }}<v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                                ><span v-bind="attrs" v-on="on">
                                                    <v-icon small dark>
                                                        mdi-dots-horizontal
                                                    </v-icon>
                                                </span>
                                            </template>
                                            <span
                                                >{{
                                                    $t(
                                                        "settings.routing.pleaseUse"
                                                    )
                                                }}
                                                <v-icon color="green"
                                                    >mdi-microsoft-excel</v-icon
                                                >{{
                                                    $t(
                                                        "settings.routing.downloadDetailsTooltip"
                                                    )
                                                }}
                                            </span>
                                        </v-tooltip>
                                    </div>
                                    <div v-else>{{ detail.filter_login }}</div>
                                </td>
                                <td style="white-space: nowrap">
                                    <div
                                        v-if="detail.filter_group.length >= 25"
                                    >
                                        {{ detail.filter_group.slice(0, 25)
                                        }}<v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                                ><span v-bind="attrs" v-on="on">
                                                    <v-icon small dark>
                                                        mdi-dots-horizontal
                                                    </v-icon>
                                                </span>
                                            </template>
                                            <span
                                                >{{
                                                    $t(
                                                        "settings.routing.pleaseUse"
                                                    )
                                                }}
                                                <v-icon color="green"
                                                    >mdi-microsoft-excel</v-icon
                                                >
                                                {{
                                                    $t(
                                                        "settings.routing.downloadDetailsTooltip"
                                                    )
                                                }}</span
                                            >
                                        </v-tooltip>
                                    </div>
                                    <div v-else>{{ detail.filter_group }}</div>
                                </td>
                                <td style="white-space: nowrap">
                                    <div
                                        v-if="detail.filter_symbol.length >= 25"
                                    >
                                        {{ detail.filter_symbol.slice(0, 25)
                                        }}<v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                                ><span v-bind="attrs" v-on="on">
                                                    <v-icon small dark>
                                                        mdi-dots-horizontal
                                                    </v-icon>
                                                </span>
                                            </template>
                                            <span
                                                >{{
                                                    $t(
                                                        "settings.routing.pleaseUse"
                                                    )
                                                }}
                                                <v-icon color="green"
                                                    >mdi-microsoft-excel</v-icon
                                                >
                                                {{
                                                    $t(
                                                        "settings.routing.downloadDetailsTooltip"
                                                    )
                                                }}</span
                                            >
                                        </v-tooltip>
                                    </div>
                                    <div v-else>{{ detail.filter_symbol }}</div>
                                </td>
                                <td style="white-space: nowrap">
                                    <div
                                        v-if="
                                            detail.filter_symbol_group.length >=
                                            25
                                        "
                                    >
                                        {{
                                            detail.filter_symbol_group.slice(
                                                0,
                                                25
                                            )
                                        }}<v-tooltip top>
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                                ><span v-bind="attrs" v-on="on">
                                                    <v-icon small dark>
                                                        mdi-dots-horizontal
                                                    </v-icon>
                                                </span>
                                            </template>
                                            <span
                                                >{{
                                                    $t(
                                                        "settings.routing.pleaseUse"
                                                    )
                                                }}
                                                <v-icon color="green"
                                                    >mdi-microsoft-excel</v-icon
                                                >
                                                {{
                                                    $t(
                                                        "settings.routing.downloadDetailsTooltip"
                                                    )
                                                }}</span
                                            >
                                        </v-tooltip>
                                    </div>
                                    <div v-else>
                                        {{ detail.filter_symbol_group }}
                                    </div>
                                </td>
                                <td>{{ detail.percentage_a }}</td>
                                <td>{{ detail.percentage_b }}</td>
                                <td>{{ detail.book_a_name }}</td>
                                <td>{{ detail.book_b_name }}</td>
                                <td>{{ detail.is_override }}</td>
                                <td>
                                    <v-icon
                                        dense
                                        v-on:click="
                                            toggleDialog('update', detail)
                                        "
                                        :disabled="loading"
                                        >mdi-pen</v-icon
                                    >
                                    &nbsp;
                                    <v-icon
                                        dense
                                        :disabled="changed || loading"
                                        v-on:click="toggleRemoveDialog(detail)"
                                        >mdi-delete</v-icon
                                    >
                                </td>
                            </tr>
                        </draggable>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialogRemove.visible"
            :fullscreen="dialogRemove.fullscreen"
            width="1200"
            :hide-overlay="true"
            :persistent="true"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">{{
                        dialogRemove.title
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="white"
                        icon
                        @click="
                            dialogRemove.fullscreen = !dialogRemove.fullscreen
                        "
                        ><v-icon>mdi-arrow-expand</v-icon></v-btn
                    >
                    <v-btn
                        color="white"
                        icon
                        @click="dialogRemove.visible = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-card-actions>
                    <v-row>
                        <v-col
                            cols="12"
                            sm="12"
                            md="12"
                            lg="12"
                            xl="12"
                        ></v-col>
                        <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                            <v-data-table
                                dense
                                :headers="removeHeader"
                                :items="removeData"
                                item-key="id"
                                class="elevation-0"
                                :loading="loading"
                                :items-per-page="-1"
                                id="home-table"
                                :hide-default-footer="true"
                                fixed-header
                                :header-props="{ sortIcon: null }"
                            >
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-card-actions>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialogRemove.visible = false"
                        :disabled="loading"
                        >{{ $t("common.form.cancel") }}</v-btn
                    >
                    <v-btn
                        color="red darken-1"
                        text
                        @click="deleteRow()"
                        :loading="loading"
                        ><span>{{ $t("common.form.confirm") }}</span></v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog.visible"
            :fullscreen="dialog.fullscreen"
            width="700"
            :hide-overlay="true"
            :persistent="true"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: rgb(26, 57, 88)"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0">{{
                        dialog.title
                    }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="white"
                        icon
                        @click="dialog.fullscreen = !dialog.fullscreen"
                        ><v-icon>mdi-arrow-expand</v-icon></v-btn
                    >
                    <v-btn color="white" icon @click="dialog.visible = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-card-actions>
                    <v-row>
                        <v-col cols="4" class="pt-4 pb-0">
                            <label
                                style="
                                    display: flex;
                                    align-items: end;
                                    height: 100%;
                                "
                            >
                                {{ $t("common.table.server") }}
                            </label>
                        </v-col>
                        <v-col cols="8" class="pt-4 pb-0">
                            <v-autocomplete
                                v-model="dialog.server_id"
                                required
                                hide-details="auto"
                                single-line
                                :items="allServerData"
                                item-text="server_name"
                                item-value="id"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" class="pt-0">
                            <v-row
                                v-for="data in filterFields"
                                :key="data.text"
                                style="margin-top: 0px"
                            >
                                <v-col cols="4" class="pb-0">
                                    <label
                                        style="
                                            display: flex;
                                            align-items: end;
                                            height: 100%;
                                        "
                                    >
                                        {{ data.text }}
                                    </label>
                                </v-col>
                                <v-col cols="2" class="pb-0">
                                    <v-select
                                        v-model="inputMode[data.value]"
                                        :items="modeOptions"
                                        hide-details
                                        @change="() => onModeChange(data.value)"
                                    ></v-select>
                                </v-col>
                                <v-col
                                    cols="6"
                                    class="pb-0"
                                    style="display: flex"
                                >
                                    <b
                                        style="
                                            margin-top: 20px;
                                            padding-right: 10px;
                                        "
                                        >{{ inputPrefix[data.value] }}</b
                                    >
                                    <div style="width: -webkit-fill-available">
                                        <v-text-field
                                            v-model="dialog[data.value]"
                                            v-if="
                                                inputMode[data.value] ===
                                                'regex'
                                            "
                                            required
                                            :placeholder="
                                                $t(
                                                    'common.form.enterNewValue'
                                                )+'Regex'
                                            "
                                            hide-details="auto"
                                            single-line
                                        >
                                        </v-text-field>
                                        <template v-else>
                                            <v-text-field
                                                v-model="dialog[data.value]"
                                                v-if="data.type === 'input'"
                                                required
                                                :placeholder="
                                                    $t(
                                                        'common.form.enterNewValue'
                                                    )
                                                "
                                                hide-details="auto"
                                                single-line
                                            >
                                            </v-text-field>
                                            <v-autocomplete
                                                v-else
                                                v-model="dialog[data.value]"
                                                required
                                                hide-details="auto"
                                                single-line
                                                :placeholder="
                                                    $t(
                                                        'common.form.enterNewValue'
                                                    )
                                                "
                                                :items="
                                                    filteredOptions[data.value]
                                                "
                                            >
                                            </v-autocomplete>
                                        </template>
                                    </div>
                                    <b
                                        style="
                                            margin-top: 20px;
                                            padding-left: 10px;
                                        "
                                        >{{ inputSuffix[data.value] }}</b
                                    >
                                </v-col>
                            </v-row>
                        </v-col>

                        <v-col cols="4" class="pt-4 pb-0">
                            <label
                                style="
                                    display: flex;
                                    align-items: end;
                                    height: 100%;
                                "
                            >
                                Book A
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            color="grey"
                                            style="padding-bottom: 3px"
                                        >
                                            mdi-information
                                        </v-icon>
                                    </template>
                                    <span>{{
                                        $t("settings.routing.bookaTooltip")
                                    }}</span>
                                </v-tooltip>
                            </label>
                        </v-col>
                        <v-col cols="8" class="pt-4 pb-0">
                            <v-autocomplete
                                dense
                                v-model="dialog.book_a_id"
                                :items="filteredBookData"
                                item-text="book_name"
                                item-value="book_id"
                                auto-select-first
                                chips
                                small-chips
                                :item-disabled="
                                    (item) => item.book_id == dialog.book_b_id
                                "
                                hide-details
                            >
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="4" class="pt-0 pb-0">
                            <label
                                style="
                                    display: flex;
                                    align-items: end;
                                    height: 100%;
                                "
                            >
                                {{ $t("common.table.percentage") }} A
                            </label>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                            <v-text-field
                                single-line
                                v-model="dialog.percentage_a"
                                hide-details="auto"
                            />
                        </v-col>

                        <v-col cols="4" class="pt-4 pb-0">
                            <label
                                style="
                                    display: flex;
                                    align-items: end;
                                    height: 100%;
                                "
                            >
                                Book B
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            color="grey"
                                            style="padding-bottom: 3px"
                                        >
                                            mdi-information
                                        </v-icon>
                                    </template>
                                    <span>{{
                                        $t("settings.routing.bookbTooltip")
                                    }}</span>
                                </v-tooltip>
                            </label>
                        </v-col>
                        <v-col cols="8" class="pt-4 pb-0">
                            <v-autocomplete
                                dense
                                v-model="dialog.book_b_id"
                                :items="filteredBookData"
                                item-text="book_name"
                                item-value="book_id"
                                auto-select-first
                                chips
                                small-chips
                                :item-disabled="
                                    (item) => item.book_id == dialog.book_a_id
                                "
                                hide-details
                            >
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="4" class="pt-0 pb-0">
                            <label
                                style="
                                    display: flex;
                                    align-items: end;
                                    height: 100%;
                                "
                            >
                                {{ $t("common.table.percentage") }} B
                            </label>
                        </v-col>
                        <v-col cols="8" class="pt-0 pb-0">
                            <v-text-field
                                v-model="dialog.percentage_b"
                                hide-details="auto"
                                single-line
                            />
                        </v-col>

                        <v-col cols="4" class="pt-4 pb-0">
                            <label
                                style="
                                    display: flex;
                                    align-items: end;
                                    height: 100%;
                                "
                            >
                                {{ $t("common.table.isOverride") }}
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                            dark
                                            v-bind="attrs"
                                            v-on="on"
                                            small
                                            color="grey"
                                            style="padding-bottom: 3px"
                                        >
                                            mdi-information
                                        </v-icon>
                                    </template>
                                    <span>{{
                                        $t("settings.routing.isOverrideTooltip")
                                    }}</span>
                                </v-tooltip>
                            </label>
                        </v-col>
                        <v-col cols="8" class="pt-4 pb-0">
                            <v-autocomplete
                                dense
                                v-model="dialog.is_override"
                                :items="overriddenOptions"
                                auto-select-first
                                chips
                                small-chips
                                hide-details
                            >
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                </v-card-actions>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="dialog.visible = false"
                        :disabled="dialog.loading"
                        >{{ $t("common.form.cancel") }}</v-btn
                    >
                    <v-btn
                        color="green darken-1"
                        text
                        @click="confirmAdd"
                        :loading="loading"
                        ><span>{{
                            dialog.type === "add"
                                ? $t("common.form.add")
                                : $t("common.form.update")
                        }}</span></v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="removeWarning"
            width="600"
            :hide-overlay="true"
            :persistent="true"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: #ff5252"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0"
                        ><v-icon>mdi-alert-circle</v-icon>
                        {{ $t("common.warning") }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="white" icon @click="removeWarning = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-card-text
                    class="text-h5 font-weight-bold"
                    style="padding: 24px 20px"
                >
                    {{ $t("settings.routing.deleteWarning") }}
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="green darken-1"
                        text
                        @click="removeWarning = false"
                        >{{ $t("common.form.confirm") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
            v-model="refreshWarning"
            width="600"
            :hide-overlay="true"
            :persistent="true"
        >
            <v-card class="pt-0">
                <v-app-bar
                    flat
                    color="rgba(0, 0, 0, 0)"
                    style="background: #ff5252"
                >
                    <v-toolbar-title class="text-h6 white--text pl-0"
                        ><v-icon>mdi-alert-circle</v-icon>
                        {{ $t("common.warning") }}</v-toolbar-title
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="white" icon @click="refreshWarning = false"
                        ><v-icon>mdi-close</v-icon></v-btn
                    >
                </v-app-bar>

                <v-card-text
                    class="text-h6 font-weight-bold"
                    style="padding: 24px 20px 0px"
                >
                    <div>
                        {{ $t("settings.routing.refreshWarning") }}
                    </div>
                    <ul style="font-size: 18px">
                        <li>
                            {{ $t("common.press") }} <v-icon>mdi-close</v-icon
                            >{{ $t("settings.routing.continueEditing") }}
                        </li>
                        <li>
                            {{ $t("common.press") }}
                            <span style="color: #e53935">{{
                                $t("common.form.discard")
                            }}</span>
                            {{ $t("settings.routing.discardChanges") }}
                        </li>
                        <li>
                            {{ $t("common.press") }}
                            <span style="color: #43a047">{{
                                $t("common.form.update")
                            }}</span>
                            {{ $t("settings.routing.saveChanges") }}
                        </li>
                    </ul>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="onDiscard">{{
                        $t("common.form.discard")
                    }}</v-btn>

                    <v-btn color="green darken-1" text @click="updateData">{{
                        $t("common.form.update")
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <UpdateConfirmation
            type="routing"
            :addition="addition"
            :edition="edition"
            :header="routingHeader"
        />
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Draggable from "vuedraggable";
import deepClone from "deep-clone";
import { snackbar } from "@components/mixins/snackbar";
import UpdateConfirmation from "./ComponentUpdateConfirmation.vue";

import _ from "lodash";
export default {
    mixins: [snackbar],
    components: {
        Draggable,
        UpdateConfirmation,
    },
    data() {
        return {
            refreshWarning: false,
            removeWarning: false,
            changed: false,
            routingSearch: "",
            filterSortData: [],
            dialogRemove: {
                title: this.$t("message.deletionConfirmation"),
                fullscreen: false,
                visible: false,
            },
            dialog: {
                type: "add",
                visible: false,
                fullscreen: false,
                title: this.$t("settings.routing.addNewRouting"),
                id: null,
                server_id: null,
                filter_login: "",
                filter_group: "",
                filter_symbol: "",
                filter_symbol_group: "",
                percentage_a: 100,
                percentage_b: 0,
                book_a_id: null,
                book_b_id: null,
            },
            addition: [],
            edition: [],
            filterFields: [
                {
                    text: this.$t("common.table.filterLogin"),
                    value: "filter_login",
                    type: "input",
                    queryType: "login",
                    page_num: 1,
                    page_size: 20,
                    done: false,
                    options: [],
                },
                {
                    text: this.$t("common.table.filterGroup"),
                    value: "filter_group",
                    type: "autocomplete",
                    queryType: "group",
                    page_num: 1,
                    page_size: 20,
                    done: false,
                    options: [],
                },
                {
                    text: this.$t("common.table.filterSymbol"),
                    value: "filter_symbol",
                    type: "autocomplete",
                    queryType: "symbol",
                    page_num: 1,
                    page_size: 20,
                    done: false,
                    options: [],
                },
                {
                    text: this.$t("common.table.filterSymbolGroup"),
                    value: "filter_symbol_group",
                    type: "autocomplete",
                    queryType: "security",
                    page_num: 1,
                    page_size: 20,
                    done: false,
                    options: [],
                },
            ],
            inputMode: {
                filter_login: "plain",
                filter_symbol: "plain",
                filter_group: "plain",
                filter_symbol_group: "plain",
            },
            filteredOptions: {
                filter_login: [],
                filter_group: [],
                filter_symbol: [],
                filter_symbol_group: [],
            },
            modeOptions: ["plain", "regex"],
            vendors: [],
            currentPage: 1,
            itemsPerPage: 10,
            overriddenOptions: [true, false],
        };
    },
    watch: {
        routingData(nv, ov) {
            this.filterSortData = deepClone(nv);
        },
        loading(nv, ov) {
            if (!nv) {
                this.dialogRemove.visible = false;
                this.dialog.visible = false;
            }
        },
        "dialog.server_id": async function (val) {
            if (this.dialog.visible) {
                const keys = Object.keys(this.filteredOptions);

                keys.map((key) => {
                    if (val === -1) {
                        this.filteredOptions[key] = this.options[key].map(
                            (item) => item.name
                        );
                    } else {
                        this.filteredOptions[key] = this.options[key]
                            .filter(
                                (item) =>
                                    item.server_id === val &&
                                    item.name.replaceAll(" ", "") !== ""
                            )
                            .map((item) => item.name);
                    }
                    this.filteredOptions[key].unshift("*");
                });
            }
        },
        "dialog.percentage_a": function (val) {
            if (val > 100) {
                this.dialog.percentage_a = 100;
            }
            this.dialog.percentage_b = 100 - val;
        },
        "dialog.percentage_b": function (val) {
            if (val > 100) {
                this.dialog.percentage_b = 100;
            }
            this.dialog.percentage_a = 100 - val;
        },
        newData(nv) {
            this.filterSortData.push(nv);
        },
    },
    computed: {
        ...mapState("SettingsRouting", [
            "routingData",
            "routingHeader",
            "loading",
            "removeHeader",
            "removeData",
            "newData",
            "csvFields",
        ]),
        ...mapState("SettingsServer", ["serverData"]),
        ...mapState("SettingsBooks", ["bookData"]),
        ...mapState("Config", ["options"]),
        allServerData() {
            return [{ server_name: "ALL", id: -1 }, ...this.serverData];
        },
        filteredBookData() {
            if (
                this.dialog.server_id &&
                this.dialog.server_id !== -1 &&
                this.bookData.length
            ) {
                const brokerId = this.serverData.filter(
                    (server) => server.id === this.dialog.server_id
                )[0].broker_id;
                const filteredBooks = this.bookData.filter(
                    (book) => book.broker_id === brokerId
                );
                return filteredBooks;
            } else if (this.dialog.server_id === -1) {
                return this.bookData;
            } else {
                return [];
            }
        },
        inputPrefix() {
            const returnValue = {};
            Object.keys(this.inputMode).map(
                (key) =>
                    (returnValue[key] =
                        this.inputMode[key] === "plain" ? "" : "regex[")
            );
            return returnValue;
        },
        inputSuffix() {
            const returnValue = {};
            Object.keys(this.inputMode).map(
                (key) =>
                    (returnValue[key] =
                        this.inputMode[key] === "plain" ? "" : "]")
            );
            return returnValue;
        },
        currentPageItems() {
            const start = (this.currentPage - 1) * this.itemsPerPage;
            return this.filterSortData.slice(start, start + this.itemsPerPage);
        },
    },
    methods: {
        ...mapActions("SettingsRouting", [
            "getRoutingsAction",
            "postRoutingAction",
            "putRoutingAction",
            "deleteRoutingAction",
        ]),
        ...mapMutations("SettingsRouting", ["UPDATE_REMOVE_DATA"]),
        toggleRemoveDialog(data) {
            if (this.changed) {
                this.removeWarning = true;
            } else {
                this.dialogRemove.visible = true;
                const temp = [data];
                this.UPDATE_REMOVE_DATA(temp);
            }
        },
        deleteRow() {
            if (this.removeData.length !== 0) {
                const params = {
                    id: this.removeData[0].id,
                    server_id: this.removeData[0].server_id,
                };
                this.deleteRoutingAction(params);
            }
        },
        onModeChange(key) {
            if (this.inputMode[key] === "regex") {
                this.dialog[key] = "";
            }
        },
        updateData() {
            const diff = [];
            let counter =
                this.routingData[this.routingData.length - 1].priority;
            for (const [index, element] of this.filterSortData.entries()) {
                if (
                    JSON.stringify(element) !==
                    JSON.stringify(this.routingData[index])
                ) {
                    if (index < this.routingData.length) {
                        const changedOne = deepClone(element);
                        changedOne.priority = this.routingData[index].priority;
                        diff.push(changedOne);
                    } else {
                        counter += 1;
                        const changedOne = deepClone(element);
                        changedOne.priority = counter;
                        diff.push(changedOne);
                    }
                }
            }
            const output = { routing: diff };

            this.putRoutingAction(output);
            this.$posthog.capture("routing_config_updated", {
                changed_count: diff.length,
            });

            this.refreshWarning = false;
            this.removeWarning = false;
            this.changed = false;
        },
        onDragEnd(evt) {
            const { oldIndex, newIndex } = evt;

            const pageStart = (this.currentPage - 1) * this.itemsPerPage;
            const currentPageItems = this.filterSortData.slice(
                pageStart,
                pageStart + this.itemsPerPage
            );
            const movedItem = currentPageItems[oldIndex];

            const actualOldIndex = this.filterSortData.findIndex(
                (i) => i.id === movedItem.id
            );

            this.filterSortData.splice(actualOldIndex, 1);
            const actualNewIndex = pageStart + newIndex;
            this.filterSortData.splice(actualNewIndex, 0, movedItem);

            if (
                JSON.stringify(this.filterSortData) ===
                JSON.stringify(this.routingData)
            ) {
                this.changed = false;
            } else {
                this.changed = true;
            }
        },
        toggleDialog(type, data = null) {
            this.dialog.visible = true;
            this.dialog.type = type;

            if (type === "add") {
                this.dialog.title = this.$t("settings.routing.addNewRouting");
                this.dialog.id = -1;
                this.dialog.server_id = null;
                this.dialog.filter_login = "";
                this.dialog.filter_group = "";
                this.dialog.filter_symbol = "";
                this.dialog.filter_symbol_group = "";
                this.dialog.percentage_a = 100;
                this.dialog.percentage_b = 0;
                this.dialog.book_a_id = null;
                this.dialog.book_b_id = null;
                this.dialog.is_override = null;
                Object.keys(this.inputMode).forEach((key) => {
                    this.inputMode[key] = "plain";
                });
            } else {
                this.dialog.title = this.$t("settings.routing.updateRouting");
                this.dialog.id = data.id;
                this.dialog.server_id = data.server_id;

                Object.keys(this.inputMode).map((item) => {
                    let plainOrRegex = "plain";
                    if (
                        data[item].includes("regex[") &&
                        data[item].includes("]") &&
                        data[item][data[item].length - 1] === "]"
                    ) {
                        plainOrRegex = "regex";
                    }
                    this.inputMode[item] = plainOrRegex;
                    if (plainOrRegex === "plain") {
                        this.dialog[item] = data[item];
                    } else {
                        this.dialog[item] = data[item]
                            .replace("regex[", "")
                            .slice(0, -1);
                    }
                });

                this.dialog.percentage_a = data.percentage_a;
                this.dialog.percentage_b = data.percentage_b;
                this.dialog.book_a_id = data.book_a_id;
                this.dialog.book_b_id = data.book_b_id;
                this.dialog.is_override = data.is_override;
            }
        },
        confirmAdd() {
            if (this.dialog.type === "add") {
                if (
                    this.dialog.server_id === null ||
                    this.dialog.server_id === undefined ||
                    this.dialog.filter_login === "" ||
                    this.dialog.filter_group === "" ||
                    this.dialog.filter_symbol === "" ||
                    this.dialog.filter_symbol_group === "" ||
                    this.dialog.percentage_a === "" ||
                    this.dialog.percentage_b === "" ||
                    this.dialog.book_b_id === null ||
                    this.dialog.book_a_id === null ||
                    this.dialog.is_override === null
                ) {
                    this.snackBarDanger(
                        this.$t("message.formCompletionWarning")
                    );
                    return;
                }

                const filterKeys = Object.keys(this.inputMode);
                filterKeys.map((key) => {
                    if (this.inputMode[key] === "regex") {
                        this.dialog[key] = "regex[" + this.dialog[key] + "]";
                    }
                });

                this.changed = true;
                this.postRoutingAction(this.dialog);
            } else {
                if (
                    this.dialog.filter_login === "" ||
                    this.dialog.filter_group === "" ||
                    this.dialog.filter_symbol === "" ||
                    this.dialog.filter_symbol_group === "" ||
                    this.dialog.percentage_a === "" ||
                    this.dialog.percentage_b === "" ||
                    this.dialog.book_a_id === null ||
                    this.dialog.book_b_id === undefined ||
                    this.dialog.book_a_id === undefined ||
                    this.dialog.book_b_id === null ||
                    this.dialog.is_override === null
                ) {
                    this.snackBarDanger(
                        this.$t("message.formCompletionWarning")
                    );
                    return;
                }

                const index = this.filterSortData.findIndex((object) => {
                    return object.id === this.dialog.id;
                });

                const filterKeys = Object.keys(this.inputMode);
                filterKeys.map((key) => {
                    if (this.inputMode[key] === "regex") {
                        this.dialog[key] = "regex[" + this.dialog[key] + "]";
                    }
                });

                const { type, visible, title, id, fullscreen, ...changes } =
                    this.dialog;

                Object.keys(changes).map((key) => {
                    this.filterSortData[index][key] = changes[key];
                });
                const aBookIndex = this.filteredBookData.findIndex(
                    (object) => object.book_id === changes.book_a_id
                );
                const bBookIndex = this.filteredBookData.findIndex(
                    (object) => object.book_id === changes.book_b_id
                );

                this.filterSortData[index].book_a_name =
                    this.filteredBookData[aBookIndex].book_name;
                this.filterSortData[index].book_b_name =
                    this.filteredBookData[bBookIndex].book_name;
                if (
                    JSON.stringify(this.filterSortData) ===
                    JSON.stringify(this.routingData)
                ) {
                    this.changed = false;
                } else {
                    this.changed = true;
                }
            }

            this.dialog.visible = false;
        },
        refreshRouting() {
            if (this.changed) {
                this.refreshWarning = true;
            } else {
                this.getRoutingsAction();
                this.refreshWarning = false;
            }
        },
        onDiscard() {
            this.changed = false;
            this.refreshRouting();
        },
        readFile(fileInput) {
            var reader = new FileReader();
            reader.onload = () => {
                var csv = reader.result
                    .replaceAll('"""', "")
                    .replaceAll('"=""', "");
                var lines = csv.split("\r\n");
                var result = [];
                var headers = lines[0].split(",");
                if (
                    JSON.stringify(headers) ===
                    JSON.stringify(Object.keys(this.csvFields))
                ) {
                    for (var i = 1; i < lines.length; i++) {
                        if (lines[i] === "") {
                            break;
                        }
                        var lineFailed = false;
                        var obj = {};
                        var currentLine = lines[i].split(",");
                        let bookA;
                        let bookB;
                        for (var j = 0; j < headers.length; j++) {
                            if (headers[j] === "Book A ID") {
                                bookA = parseInt(currentLine[j]);
                            }
                            if (headers[j] === "Book B ID") {
                                bookB = parseInt(currentLine[j]);
                            }
                            if (headers[j] === "Book A Name") {
                                const locatedId = this.bookData.find(
                                    (item) =>
                                        item.book_name.toUpperCase() ===
                                        currentLine[j].toUpperCase()
                                )?.book_id;
                                if (bookA !== locatedId) {
                                    obj[
                                        this.csvFields[
                                            headers[
                                                headers.indexOf("Book A ID")
                                            ]
                                        ]
                                    ] = locatedId ? locatedId.toString() : null;
                                }
                            }
                            if (headers[j] === "Book B Name") {
                                const locatedId = this.bookData.find(
                                    (item) =>
                                        item.book_name.toUpperCase() ===
                                        currentLine[j].toUpperCase()
                                )?.book_id;
                                if (bookB !== locatedId) {
                                    obj[
                                        this.csvFields[
                                            headers[
                                                headers.indexOf("Book B ID")
                                            ]
                                        ]
                                    ] = locatedId ? locatedId.toString() : null;
                                }
                            }

                            obj[this.csvFields[headers[j]]] = currentLine[j];
                        }
                        if (lineFailed) {
                            continue;
                        }
                        result.push(obj);
                    }

                    this.addition = [];
                    this.edition = [];
                    const add = [];
                    result.map((item) => {
                        add.push(item);
                    });
                    if (add.length === 0) {
                        this.snackBarSuccess(
                            this.$t("message.allSettingsUpToDate")
                        );
                    } else {
                        this.addition = [...add];
                    }
                } else {
                    this.snackBarDanger(this.$t("message.invalidFile"));
                }
            };
            reader.readAsText(fileInput);
        },
        resetFileInput() {
            this.$refs.routingFile.value = "";
            this.$refs.routingFile.click();
        },
    },
    mounted() {
        this.getRoutingsAction();
    },
};
</script>

<style scoped>
.v-tooltip__content.menuable__content__active {
    opacity: 1 !important;
    background-color: gray;
}
</style>
